export const DNA_TRAITS = {
  funny: {
    label: 'Funny',
    description: 'Consistently brings humor and laughter to streams',
    command: '!funny',
    icon: '😂'
  },
  rage: {
    label: 'Unfiltered',
    description: 'Expressive and passionate streamer',
    command: '!rage',
    icon: '😤'
  },
  leader: {
    label: 'Leader',
    description: 'Takes charge and guides their team to victory',
    command: '!leader',
    icon: '👑'
  },
  clutch: {
    label: 'Clutch Player',
    description: 'Performs best under pressure',
    command: '!clutch',
    icon: '🎯'
  },
  wild: {
    label: 'Wild Card',
    description: 'Expect the unexpected',
    command: '!wild',
    icon: '🃏'
  },
  unhinged: {
    label: 'Unpredictable Energy',
    description: 'High energy and spontaneous content',
    command: '!unhinged',
    icon: '🌪️'
  },
  entertainer: {
    label: 'Entertainer',
    description: 'Born to perform and entertain',
    command: '!entertainer',
    icon: '🎭'
  },
  troll: {
    label: 'Trickster',
    description: 'Master of clever and fun mischief',
    command: '!troll',
    icon: '😈'
  },
  unbeatable: {
    label: 'Unbeatable',
    description: 'Consistently dominates in their game',
    command: '!unbeatable',
    icon: '🏆'
  }
};

export const STREAMER_COMMANDS = {
  resetDna: '!resetdna',
  lockDna: '!lockdna'
};

export const VOTE_COOLDOWN = 5 * 60 * 1000; // 5 minutes in milliseconds

export const MAX_TRAIT_DISPLAY = 5; // Number of top traits to display

export const DNA_LEVELS = {
  1: { minScore: 0, label: 'Novice' },
  2: { minScore: 100, label: 'Rising Star' },
  3: { minScore: 500, label: 'Established' },
  4: { minScore: 1000, label: 'Elite' },
  5: { minScore: 5000, label: 'Legendary' }
}; 